
const noop = () => { };

class EventDelegate {
    constructor(element) {
        this.element = element;
    }

    on(eventName, selector, handler = noop) {
        this.element.addEventListener(eventName, (event) => {
            const target = event.target;
            const element = target.closest(selector);

            if (element) {
                const delegatedEvent = {
                    originalEvent: event,
                    currentTarget: element,
                    delegateTarget: event.currentTarget
                };

                handler(delegatedEvent);
            }
        });
    }
}

export default EventDelegate;
